import { DatePicker } from 'antd';
import React, { useState } from 'react'
import axios from 'axios';
import Select from 'react-select'
import Swal from 'sweetalert2';
import PropTypes from 'prop-types';

const AddCoupons = ({ onRefresh }) => {
    const [name, setName] = useState('');
    const [code, setCode] = useState('');
    const [type, setType] = useState({ value: 'Fixed', label: 'Fixed' });
    const [discount, setDiscount] = useState('');
    const [limit, setLimit] = useState(0);
    const [validUntil, setValidUntil] = useState(null);
    const [isActive, setIsActive] = useState(true);

    const typeOptions = [
        { value: 'Fixed', label: 'Fixed' },
        { value: 'Percentage', label: 'Percentage' },
    ];

    const handleSubmit = async (e) => {
        e.preventDefault();
        const d = Number(discount);
        const lim = Number(limit);
        if (!Number.isFinite(d) || d < 0) {
            Swal.fire('Invalid value', 'Discount must be zero or positive', 'error');
            return;
        }
        if (type.value === 'Percentage' && d > 100) {
            Swal.fire('Invalid value', 'Percentage discount cannot exceed 100', 'error');
            return;
        }
        if (!Number.isFinite(lim) || lim < 0) {
            Swal.fire('Invalid value', 'Usage limit cannot be negative', 'error');
            return;
        }
        try {
            const payload = {
                name,
                code,
                type: type.value,
                discount: d,
                limit: lim,
                validUntil,
                isActive
            };
            await axios.post("https://avastar-pos-backend.onrender.com/api/coupons", payload);
            Swal.fire('Success', 'Coupon created successfully', 'success');
            onRefresh();
            // Reset form
            setName(''); setCode(''); setDiscount(''); setLimit(0); setValidUntil(null);
            document.getElementById('close-add-coupon').click();
        } catch (error) {
            Swal.fire('Error', error.response?.data?.message || 'Failed to create coupon', 'error');
        }
    };

    return (
        <div className="modal fade" id="add-units">
            <div className="modal-dialog modal-dialog-centered custom-modal-two">
                <div className="modal-content">
                    <div className="page-wrapper-new p-0">
                        <div className="content">
                            <div className="modal-header border-0 custom-modal-header">
                                <div className="page-title">
                                    <h4>Add Coupon</h4>
                                </div>
                                <button type="button" id="close-add-coupon" className="close" data-bs-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">Ã—</span>
                                </button>
                            </div>
                            <div className="modal-body custom-modal-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <div className="mb-3">
                                                <label className="form-label">Coupon Name</label>
                                                <input type="text" className="form-control" value={name} onChange={(e) => setName(e.target.value)} required />
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="mb-3">
                                                <label className="form-label">Coupon Code</label>
                                                <input type="text" className="form-control" value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} required />
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="mb-3">
                                                <label className="form-label">Type</label>
                                                <Select className="select" options={typeOptions} value={type} onChange={(val) => setType(val)} />
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="mb-3">
                                                <label className="form-label">Discount Value</label>
                                                <input type="number" className="form-control" value={discount} onChange={(e) => setDiscount(e.target.value)} required />
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="mb-3">
                                                <label className="form-label">Limit (0 for Unlimited)</label>
                                                <input type="number" min="0" className="form-control" value={limit} onChange={(e) => setLimit(e.target.value)} />
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="mb-3">
                                                <label className="form-label">Valid Until</label>
                                                <DatePicker 
                                                    className="form-control" 
                                                    onChange={(date) => setValidUntil(date ? date.toDate() : null)} 
                                                    getPopupContainer={(trigger) => trigger.parentNode}
                                                    popupStyle={{ zIndex: 9999 }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="status-toggle modal-status d-flex justify-content-between align-items-center mb-3">
                                                <span className="status-label">Is Active?</span>
                                                <input type="checkbox" id="active-check" className="check" checked={isActive} onChange={(e) => setIsActive(e.target.checked)} />
                                                <label htmlFor="active-check" className="checktoggle"></label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer-btn">
                                        <button type="button" className="btn btn-cancel me-2" data-bs-dismiss="modal">Cancel</button>
                                        <button type="submit" className="btn btn-submit">Create Coupon</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

AddCoupons.propTypes = {
    onRefresh: PropTypes.func.isRequired,
};

export default AddCoupons
